import script from "./QuoteProductQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteProductQuestion.vue?vue&type=script&setup=true&lang=js"

import "./QuoteProductQuestion.vue?vue&type=style&index=0&id=42aad4f2&scoped=true&lang=scss"

import exportComponent from "/Users/ben/Local Sites/serenialife-public/app/public/wp-content/themes/serenialife-public-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42aad4f2"]])

export default __exports__